import { IconButton } from '@vkontakte/vkui';
import { Icon24MoreHorizontal } from '@vkontakte/icons';
import { CatBadge, catTone } from '../../ui/CatBadge';
import type { TaskCategory } from '../../types';

type Props = {
  category: TaskCategory | null;
  name: string;
  iconId?: number | null;
  total: number;
  done: number;
  expanded: boolean;
  onToggle: () => void;
  onMenu: (anchor: Element) => void;
};

export function CategoryCard(p: Props) {
  const tone = p.category ? catTone(p.iconId) : 'rose';
  const pct = p.total ? Math.round((p.done / p.total) * 100) : 0;
  return (
    <div className={`tp-catcard tp-card--${tone}${p.expanded ? ' tp-catcard--expanded' : ''}`}>
      <div className="tp-card__strip" />
      <div className="tp-catcard__main" onClick={p.onToggle}>
        <CatBadge iconId={p.iconId} size={36} />
        <div className="tp-catcard__body">
          <div className="tp-catcard__name">{p.name}</div>
          <div className="tp-catcard__stats">
            {p.total} задач · {p.done} выполнено
          </div>
          <div className="tp-catcard__bar">
            <div className="tp-catcard__bar-fill" style={{ width: `${pct}%` }} />
          </div>
        </div>
      </div>
      <div
        className="tp-card__actions"
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        onTouchStart={(e) => e.stopPropagation()}
      >
        <IconButton label="Дополнительные действия" onClick={(e) => p.onMenu(e.currentTarget)}>
          <Icon24MoreHorizontal />
        </IconButton>
      </div>
    </div>
  );
}
